import axios from "../http";

let module = "/test";

function getTest(data) {
    return axios.get(module, {params:data});
}

function getTestOne(id) {
    return axios.get(module + "/" + id);
}

function postTest(data) {
    return axios.post(module, data);
}

function putTest(data) {
    return axios.put(module, data);
}

function deleteTest(id){
    return axios.delete(module+"/"+id);
}
export default {
    getTest,getTestOne,postTest,putTest,deleteTest
}
